var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { class: { "lexon-view-container": !_vm.showSpinnerLayer } },
    [
      Object.keys(_vm.listConfiguration).length &&
      _vm.reportsData &&
      !_vm.showSpinnerLayer
        ? _c("GridTable", {
            attrs: {
              itemsData: _vm.reportsData,
              gridConfiguration: _vm.listConfiguration["Config"],
              title: _vm.$t("views.reports.title"),
              toolbarOptions: _vm.toolbarOptionsCustom,
              contextMenuItems: _vm.contextMenuItemsReportList,
              listName: _vm.listConfiguration["Alias"],
              context: _vm.context,
              allowGrouping: "",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }